import React from 'react';

import { ga4Event } from '../../../../_Apps/shared/utils/ga4Event';

const PropertyHuntCard = () => {
  const handleClick = () => {
    ga4Event('start_property_hunt_adverts_listing')
    window.location.href = '/chasse-immobiliere';
  };

  return(
    <div
      onClick={handleClick} className='vesta-cursor-pointer'
      role='button'
      target={`${window.innerWidth > 768 ? '_blank' : '_self'}`}
      rel='noreferrer'>
      <div className='vesta-sale-card vesta-estimation-card'>
        <div className={`typo-h3 vesta-text-center vesta-indigo-100 ${window.innerWidth > 1090 && 'vesta-margin-x-20'}`}>
          Nous trouvons votre bien pour vous
        </div>

        <div className='vesta-button--primary typo-bold-content vesta-text-center'>
          Découvrir notre <br /> service de chasse
        </div>

        <div className='vesta-text-center vesta-indigo-100 vesta-subtext'>
          <i className='fa-solid fa-check vesta-margin-r-5 vesta-blue-100'></i>
          Gratuit et sans engagement
        </div>
      </div>
    </div>
  )
};

export default PropertyHuntCard;
